import { type AuthenticatedState, pdsTransportFor } from "./auth.ts";
import { PostInteractions } from "./interaction-repository.ts";

let cached:
  | { readonly scopes: ReadonlySet<string>; readonly repository: PostInteractions }
  | undefined;

export function postInteractions(state: AuthenticatedState): PostInteractions {
  if (!cached || cached.scopes !== state.scopes) {
    const viewer = state.did as `did:${string}`;
    cached = {
      scopes: state.scopes,
      repository: new PostInteractions(viewer, state.scopes, pdsTransportFor(viewer)),
    };
  }
  return cached.repository;
}
